import { toast } from "sonner";

/**
 * Rate limits of the server (HTTP 429, docs/13-betrieb.md): one friendly
 * message at a time, and the wait the server asks for.
 */

const FALLBACK_MS = 30_000;

/** Wait from the Retry-After header (seconds), capped so the app never pauses for long. */
export function retryAfterMs(response: Response, fallback = FALLBACK_MS): number {
  const seconds = Number(response.headers.get("retry-after"));
  if (!Number.isFinite(seconds) || seconds <= 0) return fallback;
  return Math.min(seconds * 1000, 10 * 60_000);
}

export const RATE_LIMIT_MESSAGE =
  "Gerade kommen sehr viele Anfragen von dir an. Bitte warte einen Moment, dann geht es weiter.";

/** Shows the message once (same toast id), however many requests were refused. */
export function noteRateLimit(message: string | undefined, waitMs: number): void {
  toast.warning(message || RATE_LIMIT_MESSAGE, {
    id: "rate-limit",
    duration: Math.max(4000, Math.min(waitMs, 15_000)),
  });
}
